import { appRepo } from '../repo';

export const appService = {
    async getOverview(params = {}) {
        try {
            const response = await appRepo.getOverview(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getOwnerDashboard(params = {}) {
        try {
            const response = await appRepo.getOwnerDashboard(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getSellerDashboard(params = {}) {
        try {
            const response = await appRepo.getSellerDashboard(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('AppService Error:', error);
        return error.response?.data || error;
    },
};